import React, { useState } from "react";

import logo from "../img/smallLogo.png";

import { NavLink } from "react-router-dom";
import { IconButton } from "@mui/material";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import HistoryIcon from "@mui/icons-material/History";
import GavelIcon from "@mui/icons-material/Gavel";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import GroupIcon from "@mui/icons-material/Group";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import SupervisedUserCircleIcon from "@mui/icons-material/SupervisedUserCircle";

export default function Sidebar() {
  const [rotateAnimation, setRotateAnimation] = useState(false);

  const closeSideBar = () => {
    document.getElementById("mySidenav").style.width = "0";
  };

  return (
    <div id="mySidenav" className="sidenav">
      <div className="flex flex-row pb-2 justify-between">
        <img
          src={logo}
          alt="logo"
          className={`w-24 ml-12 mt-5 transition-transform transform ${
            rotateAnimation ? "rotate-180" : ""
          }`}
          style={{ transitionDuration: "3s" }}
        />

        <button onClick={closeSideBar}>
          <CloseSharpIcon
            className="mb-10 mr-3 text-gray-500"
            sx={{ fontSize: 40 }}
          />
        </button>
      </div>

      <ul className="flex flex-col justify-start pt-8 text-gray-600">
        <li className="h-12 bg-white hover:bg-[#ec644c] active:bg-[#ec644c] flex items-center">
          <NavLink className="flex items-center" to="/transactionRequests">
            <ImportExportIcon sx={{ marginRight: 2, marginLeft: 2 }} />
            Transaction Requests
          </NavLink>
        </li>
        <li className="h-12 bg-white hover:bg-[#ec644c] active:bg-[#ec644c] flex items-center">
          <NavLink className="flex items-center" to="/pastTransactions">
            <HistoryIcon sx={{ marginRight: 2, marginLeft: 2 }} />
            All Past Transactions
          </NavLink>
        </li>
        <li className="h-12 bg-white hover:bg-[#ec644c] active:bg-[#ec644c] flex items-center">
          <NavLink className="flex items-center" to="/pendingRequests">
            <PersonAddAltIcon sx={{ marginRight: 2, marginLeft: 2 }} />
            Registration Requests
          </NavLink>
        </li>
        <li className="h-12 bg-white hover:bg-[#ec644c] active:bg-[#ec644c] flex items-center">
          <NavLink className="flex items-center" to="/users">
            <GroupIcon sx={{ marginRight: 2, marginLeft: 2 }} />
            Active Users
          </NavLink>
        </li>
        <li className="h-12 bg-white hover:bg-[#ec644c] active:bg-[#ec644c] flex items-center">
          <NavLink className="flex items-center" to="/principals">
            <SupervisedUserCircleIcon sx={{ marginRight: 2, marginLeft: 2 }} />
            Active Principals
          </NavLink>
        </li>
        <li className="h-12 bg-white hover:bg-[#ec644c] active:bg-[#ec644c] flex items-center">
          <NavLink className="flex items-center" to="/settings">
            <AdminPanelSettingsIcon sx={{ marginRight: 2, marginLeft: 2 }} />
            Principal Management
          </NavLink>
        </li>
        <li className="h-12 bg-white hover:bg-[#ec644c] active:bg-[#ec644c] flex items-center">
          <NavLink className="flex items-center" to="/termsAndConditions">
            <GavelIcon sx={{ marginRight: 2, marginLeft: 2 }} />
            Terms and Conditions
          </NavLink>
        </li>
      </ul>

      {/* <ul className="flex flex-col justify-start pt-8 text-gray-600">
        <li className="h-12 bg-white hover:bg-[#ec644c] active:bg-[#ec644c] flex">
          <NavLink to="/transactionRequests">
            <ImportExportIcon sx={{ marginRight: 2, marginLeft: 2 }} />
            Transaction Requests
          </NavLink>
        </li>
        <li className="h-12 bg-white hover:bg-[#ec644c] active:bg-[#ec644c] flex ">
          <NavLink className="" to="/pastTransactions">
            <HistoryIcon sx={{ marginRight: 2, marginLeft: 2 }} />
            All Past Transactions
          </NavLink>
        </li>
        <li className="h-12 bg-white hover:bg-[#ec644c] active:bg-[#ec644c] flex ">
          <NavLink className="" to="/pendingRequests">
            <PersonAddAltIcon sx={{ marginRight: 2, marginLeft: 2 }} />
            Registration Requests
          </NavLink>
        </li>
        <li className="h-12 bg-white hover:bg-[#ec644c] active:bg-[#ec644c] flex items-center">
  <NavLink className="flex items-center" to="/users">
    <GroupIcon sx={{ marginRight: 2, marginLeft: 2 }} />
    Active Users
  </NavLink>
</li>
        <li className="h-12 bg-white hover:bg-[#ec644c] active:bg-[#ec644c] flex ">
          <NavLink className="" to="/principals">
            <SupervisedUserCircleIcon sx={{ marginRight: 2, marginLeft: 2 }} />
            Active Principals
          </NavLink>
        </li>
        <li className="h-12 bg-white hover:bg-[#ec644c] active:bg-[#ec644c] flex">
          <NavLink className="" to="/settings">
            <AdminPanelSettingsIcon sx={{ marginRight: 2, marginLeft: 2 }} />
            Principal Management
          </NavLink>
        </li>
        <li className="h-12 bg-white hover:bg-[#ec644c] active:bg-[#ec644c] flex">
          <NavLink className="" to="/termsAndConditions">
            <GavelIcon sx={{ marginRight: 2, marginLeft: 2 }} />
            Terms and Conditions
          </NavLink>
        </li>
      </ul> */}
    </div>
  );
}
